export default __webpack_public_path__ + "static/media/whatsapp-white.deb0222d.png";